'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { Button } from '@/app/components/button';
import { SPARTAN_PRODUCT_ADAS_LABELS } from '@/app/lcv/components/sections/spartan/products/adas/constants';
import type { SpartanProductAdasCtaButtonProps } from '@/app/lcv/components/sections/spartan/products/adas/cta-button/types';
import { SPARTAN_PRODUCT_ADAS_DATA_GA, SPARTAN_PRODUCT_ADAS_TRACKING } from '@/app/lcv/components/sections/spartan/products/adas/tracking';
import { SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_ID } from '@/app/lcv/components/sections/spartan/products/explore-features/constants';
import { setSpartanExploreFeaturesDetailId } from '@/app/lcv/components/sections/spartan/products/explore-features/utils';
import { SPARTAN_PRODUCT_BUTTON_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/icon-button';
import { SPARTAN_PRODUCTS_EVENT_NAME } from '@/app/lcv/components/sections/spartan/products/shared/tracking';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export const SpartanProductAdasCtaButton = t0 => {
  const $ = _c(13);
  const {
    cta,
    className
  } = t0;
  const pathname = usePathname();
  const label = cta.label ?? SPARTAN_PRODUCT_ADAS_LABELS.cta;
  let t1;
  if ($[0] !== pathname) {
    t1 = () => {
      setSpartanExploreFeaturesDetailId(pathname ?? "", SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_ID);
    };
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenExploreFeatures = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = createDataAttributes({
      test: SPARTAN_PRODUCT_ADAS_TRACKING.cta
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cta.href || $[4] !== label) {
    t3 = createDataGA({
      eventName: SPARTAN_PRODUCTS_EVENT_NAME,
      group: SPARTAN_PRODUCT_ADAS_DATA_GA.section,
      click: true,
      text: label,
      url: cta.href
    });
    $[3] = cta.href;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== className) {
    t4 = cn(SPARTAN_PRODUCT_BUTTON_CLASS_NAME, "max-xs:w-full", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleOpenExploreFeatures || $[9] !== label || $[10] !== t3 || $[11] !== t4) {
    t5 = <Button type="button" size="md" width="min" color="white" onClick={handleOpenExploreFeatures} {...t2} {...t3} className={t4}>{label}</Button>;
    $[8] = handleOpenExploreFeatures;
    $[9] = label;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};